import React from "react";
import VideocamIcon from '@mui/icons-material/Videocam';
import VideocamOffIcon from '@mui/icons-material/VideocamOff';
import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import useSystemState from "~/features/System/stores/SystemState";
import { useLang } from "~/hooks/useLang";

export default function CameraButton() {
  const { translate } = useLang();
  const { windowManager } = useSystemState();
  const theme = useTheme();

  const handleShowCameraInMap = () => {
    windowManager()['mapSetting']['markersView'].camera.show.set(!windowManager()['mapSetting']['markersView'].camera.show.get())
  }

  return (
    <IconButton
      title={`${windowManager()['mapSetting']['markersView'].camera.show.get()
        ? translate('Hide cameras')
        : translate('Show cameras')}`}
      onClick={() => handleShowCameraInMap()} color="primary"
      sx={{
        minWidth: '40px',
        width: '40px',
        height: '40px',
        borderRadius: '4px',
        color: 'text.primary',
        ':hover': {
          background: theme.palette.action.hover,
          border: `1px solid ${theme.palette.divider}`,
        }
      }}
    >
      {windowManager()['mapSetting']['markersView'].camera.show.get()
        ? <VideocamIcon />
        : <VideocamOffIcon />}
    </IconButton>
  );
}
